import {all} from 'redux-saga/effects';

const categoryWatcher = function* categoryWatcher() {
    yield all([]);
};

export default categoryWatcher;
